export default {
  /**
   * KNOWLEDGE
   */
  focusKnowledge: (state) => state.focusKnowledge,
  focusKnowledgeId: (state) =>
    state.focusKnowledge ? state.focusKnowledge.id : null,
};
